
import { setStroe, getStore } from '@/util/util.js'
const state = {
  state: {
    cWidth: getStore({
      name: 'cWidth'
    }),
    DeviceId: getStore({
      name: 'DeviceId'
    })
  },
  mutations: {
    setCWidth(state, cWidth) {
      state.cWidth = cWidth
      setStroe({
        name: "cWidth",
        content: cWidth,
      })
    },
    setDeviceId(state, DeviceId) {
      state.DeviceId = DeviceId
      setStroe({
        name: "DeviceId",
        content: DeviceId,
      })
    }
  },
}
export default state